import { css } from '@emotion/core';

import {
  DISABLED_BACKGROUND_COLOR,
  DISABLED_BORDER_COLOR,
  TEXT_COLOR,
} from './styleVariables';

const checkboxLabelStyleOverrides = css`
  color: ${TEXT_COLOR};
  font-size: 13px;
  font-weight: normal;
  height: auto;
  line-height: 1.38;
  min-height: 28px;
  padding-left: 37px;

  &::before {
    top: 3px;
  }

  &::after {
    top: 7px;
  }
`;

const passwordStyleOverrides = css`
  &:disabled {
    background: ${DISABLED_BACKGROUND_COLOR};
    border-color: ${DISABLED_BORDER_COLOR};
  }
`;

export { checkboxLabelStyleOverrides, passwordStyleOverrides };
